module.exports = __webpack_public_path__ + "assets/img/zanwuxiaoxi@2x.7b7f6b30.png";